export const getFileContent = (file, callback) => {
    const reader = new FileReader()
    reader.onload = e => callback(e.target.result)
    reader.readAsText(file)
}

export const isZip = type => {
    return ['application/zip', 'application/x-zip-compressed', 'multipart/x-zip'].includes(type)
}

export const isCsv = type => {
    return ['text/csv', 'application/csv', 'application/vnd.ms-excel', 'text/plain'].includes(type)
}
